<template>
  <div class="SEPropertiesChooseComponent">
    <p>{{ lang.infotext_1 }}:</p>
    <small>{{ lang.infotext_2 }}</small>
    <p v-if="noData">Result from SE: No data</p>
    <LoaderComponent v-show="!isData"></LoaderComponent>
    <!-- <ul v-if="isData"  :id="id" class="library_ul">
            <ItemSETree :action="action" :lang="lang.TreeItem" :searchString="searchString"  class="item"   :model="dataTree"  :edit="iscategory" ></ItemSETree>
        </ul> -->

    <div class="list-details inline">
      <b-list-group>
        <b-list-group-item v-for="(item, index) in se_trees" :key="index">
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <b-form-radio v-model="selected" name="some-radios" :value="item.ComID"
                >{{ item.PartNumber }} | {{ item.Manufacturer }} | {{ item.Description }} | <b-badge :variant="setVariant(item.LifeCycle)">{{ item.LifeCycle}}</b-badge>
              </b-form-radio>
            </b-col>
            <b-col cols="auto">
              <b-button
                @click="toggleCollapse(index)"
                :variant="variant"
                size="sm"
                class="collapse-btn inline"
                >Details</b-button
              >
            </b-col>
          </b-row>

          <b-collapse :visible="visibleIndices.includes(index)" class="mt-2">
            <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText">
              <b-card-text>
                <!-- <TreeSEComponent :data="item.seDetails"></TreeSEComponent> -->
                <span class="part-list">
                  <p>PartNumber: {{ item.PartNumber }}</p>
                  <p>Manufacturer: {{ item.Manufacturer }}</p>
                  <p>Description: {{ item.Description }}</p>
                  <p>Datasheet: <a :href="item.Datasheet" target="_blank">{{ item.Datasheet }}</a></p>
                  <p>PlName: {{ item.PlName }}</p>
                  <p>LifeCycle: <b-badge :variant="setVariant(item.LifeCycle)">{{ item.LifeCycle }}</b-badge></p>
                  <p>MatchRating: {{ item.MatchRating }}</p>
                </span>
              </b-card-text>
            </b-card>
          </b-collapse>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>
import LoaderComponent from "@/components/shared/LoaderComponent";
import TreeSEComponent from "@/components/shared/TreeSEComponent";

//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: "SEPropertiesChooseComponent",
  props: {
    lang: Object,
    data: Object,
  },
  components: {
    TreeSEComponent,
    LoaderComponent,
    //ItemSETree
  },
  data() {
    return {
      se_trees: {},
      isData: false,
      selected: null,
      noData: false,
      visibleIndices: [],
    };
  },
  computed: {
    val() {
      return 1;
    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }
    },
    colors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ["tabs-bg-dark", "tabs-text-light"];
      } else {
        return ["tabs-bg-light", "tabs-text-dark"];
      }
    },
    textColors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ["tabs-bg-dark", "tabs-text-light"];
      } else {
        return ["tabs-bg-light", "tabs-text-dark"];
      }
    },
    cardColorsBg() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "dark";
      } else {
        return "secondary";
      }
    },
    cardColorsText() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "white";
      } else {
        return "dark";
      }
    },
  },
  created() {
    this.getSEDetails();
  },
  watch: {
    selected: function (newVal) {
      
      const obj = {
        comId: newVal,
      };

      this.$store.commit("SELECTPARTSE", obj);

      const objModal = {
        ok: false,
        cancel: false,
      };

      this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal);
    },
  },

  methods: {
    toggleCollapse(index) {
      if (this.visibleIndices.includes(index)) {
        this.visibleIndices = this.visibleIndices.filter((i) => i !== index);
      } else {
        this.visibleIndices.push(index);
      }
    },
    getSEDetails() {
      this.isData = false;
      let vue = this;

      const obj = {
        distributorPartId: this.data.distributorPartId,
      };

      this.$store.dispatch("pm_getSuggestionsFromSE", obj).then(function (result) {
        console.log(result.data);

        if (result.status == "OK") {
          vue.isData = true;

          if (result.data.length > 0) {
            vue.se_trees = result.data;
          } else {
            vue.noData = true;
          }
          

          // if (vue.se_trees.length == 1) {
          //     vue.selected = vue.se_trees[0].comId;
          // }
        } else {
          vue.isData = false;
          
        }
      });
    },
    setVariant(item) {

      let res = "primary";

      if (item == "Obsolete") {
        res = "danger";
      }
      if (item == "Active") {
        res = "success";
      }

      return res;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.part-list p {
  margin: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SEPropertiesChooseComponent.vue